import {common_utils} from "../common/common_utils";
function game_1008()
{

}

game_1008.read_odd = function(id)
{
      if(id === 1)
      {
          return "2";
      }
      else if(id === 2)
      {
          return "2";
      }
      else if(id === 3)  {
          return "3";
      }
      else if(id === 4)  {
        return "4";
      }
      else if(id === 5){
        return "5";
      }
      else if(id === 6){
        return "6";
      }
      else if(id === 7){
        return "7";
      }
      else if(id === 8){
        return "8";
      }
      else if(id === 9){
        return "9";
      }
      else if(id === 10){
        return "12";
      }
      else if(id === 11){
        return "15";
      }
      else if(id === 12){
        return "18";
      }
      else if(id === 13){
        return "20";
      }
      else if(id === 16){
        return "30";
      }
      else if(id === 17){
        return "40";
      }
      else if(id === 18){
        return "50";
      }
      else if(id === 19){
        return "60";
      }
      else if(id === 20){
        return "70";
      }
      else if(id === 21)  {
        return "80";
      }
      else if(id === 22)  {
        return "100";
      }
      else if(id === 23)  {
        return "120";
      }
      else if(id === 24)  {
        return "130";
      }
      else if(id === 25)  {
        return "150";
      }
      else if(id === 26)  {
        return "10";
      }
      else if(id === 27)  {
        return "100-200-300";
      }
      else if(id === 28)  {
        return "90";
      }
      else if(id === 29){
        return  "100";
      }
      else if(id === 50){
        return "60-120-180-300";
      }
      else if(id === 51){
        return "40-200";
      }
      else if(id === 52){
        return "10";
      }
      else if(id === 53){
        return "10";
      }
      else if(id === 54){
        return "100-300";
      }
}

export {
  game_1008
};



// WEBPACK FOOTER //
// ./src/components/fish/game_1008.js